module.exports = __webpack_public_path__ + "media/images/app/about/slider_mobile-b14614d3b21d3d599c135895feb5abe1.webp";